<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div
                  class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  "
                >
                  <div
                    class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    "
                  >
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Список товаров
                      </h3>
                    </div>
                    <div class="icons d-flex">
                      <router-link
                        to="/admin/add-product"
                        class="btn ml-2 p-0 kt_notes_panel_toggle"
                        data-toggle="tooltip"
                        title=""
                        data-placement="right"
                        data-original-title="Check out more demos"
                        v-if="$parent.permissions.includes('product-manage')"
                      >
                        <span
                          class="
                            bg-secondary
                            h-30px
                            font-size-h5
                            w-30px
                            d-flex
                            align-items-center
                            justify-content-center
                            rounded-circle
                            shadow-sm
                          "
                        >
                          <svg
                            width="25px"
                            height="25px"
                            viewBox="0 0 16 16"
                            class="bi bi-plus white"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                            ></path>
                          </svg>
                        </span>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div>
                      <div class="table-responsive" id="printableTable">
                        <div
                          id="product_wrapper"
                          class="dataTables_wrapper no-footer"
                        >
                          <div class="product_toolbar">
                            <div class="ptf-item ptf-count">
                              <label>Показать</label>
                              <select
                                name="product_length"
                                v-model="limit"
                                v-on:change="fetchproducts(pagination.current_page, limit)"
                              >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                              </select>
                            </div>

                            <div class="ptf-item ptf-search">
                              <label>Поиск по названию</label>
                              <input
                                type="text"
                                placeholder="Название, ID, SKU, штрихкод..."
                                v-model="searchParameter"
                                @keyup="searchProducts()"
                              />
                            </div>

                            <div class="ptf-item">
                              <label>Категория</label>
                              <multiselect
                                class="ptf-multiselect"
                                v-model="selectedCategory"
                                :options="categories"
                                :custom-label="categoryLabel"
                                track-by="id"
                                placeholder="Поиск категории..."
                                selectLabel=""
                                selectedLabel=""
                                deselectLabel=""
                                :allow-empty="true"
                                @input="onCategorySelect"
                              ></multiselect>
                            </div>

                            <div class="ptf-item">
                              <label>Коллекция</label>
                              <select v-model="filterCollection" @change="applyFilters">
                                <option value="">Все коллекции</option>
                                <option v-for="col in collections" :key="'col'+col.id" :value="col.id">
                                  {{ col.full_path || (col.details && col.details[0] ? col.details[0].collection_name : ('#' + col.id)) }}
                                </option>
                              </select>
                            </div>

                            <div class="ptf-item">
                              <label>Статус</label>
                              <select v-model="filterStatus" @change="applyFilters">
                                <option value="">Все статусы</option>
                                <option value="active">Активен</option>
                                <option value="inactive">Неактивен</option>
                              </select>
                            </div>

                            <div class="ptf-item">
                              <label>Остаток</label>
                              <select v-model="filterStock" @change="applyFilters">
                                <option value="">Любой остаток</option>
                                <option value="in_stock">В наличии</option>
                                <option value="out_of_stock">Нет в наличии</option>
                              </select>
                            </div>

                            <div class="ptf-item ptf-reset" v-if="filterCategory || filterCollection || filterStatus || filterStock || searchParameter">
                              <button @click="clearFilters" type="button">Сбросить фильтры</button>
                            </div>
                          </div>

                          <table
                            id="product"
                            class="display dataTable no-footer"
                            product="grid"
                          >
                            <thead class="text-body">
                              <tr product="row">
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 10px"
                                  @click="sorting('id')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'id'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'id'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                  ID
                                </th>
                                  <th class="no-sort sorting_disabled" tabindex="0" rowspan="1" colspan="1" aria-label="product: activate to sort column ascending" style="width: 20px;"></th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('title')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'title'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'title'
                                      ? 'sorting_desc'
                                      : 'sorting'">
                                    Название
                                </th>
<!--                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"-->
<!--                                  @click="sorting('category_name')"-->
<!--                                  :class="-->
<!--                                    (this.$data.sortType == 'asc' ||-->
<!--                                      this.$data.sortType == 'ASC') &&-->
<!--                                    this.$data.sortBy == 'category_name'-->
<!--                                      ? 'sorting_asc'-->
<!--                                      : (this.$data.sortType == 'desc' ||-->
<!--                                          this.$data.sortType == 'DESC') &&-->
<!--                                        this.$data.sortBy == 'category_name'-->
<!--                                      ? 'sorting_desc'-->
<!--                                      : 'sorting'">-->
<!--                                  Категория-->
<!--                                </th>-->
                                <th class="d-none sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('product_type')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_type'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_type'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                    Тип
                                </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('price')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'price'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'price'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                  Цена B2C
                                </th>
                                  <th class="no-sort sorting_disabled" tabindex="0" rowspan="1" colspan="1" aria-label="B2B Price" style="width: 31.25px">
                                      Цена B2B
                                  </th>
                                  <th class="no-sort sorting_disabled" tabindex="0" rowspan="1" colspan="1" aria-label="Purchase Price" style="width: 31.25px">
                                      Цена закупки
                                  </th>
                                  <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                      @click="sorting('product_sku')"
                                      :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_sku'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_sku'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                      Артикул
                                  </th>
                                  <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                      @click="sorting('product_availability_status')"
                                      :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_availability_status'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_availability_status'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                      Остаток
                                  </th>
                                <th class="sorting" tabindex="0" rowspan="1" colspan="1" aria-sort="ascending" aria-label="ID: activate to sort column descending" style="width: 31.25px"
                                  @click="sorting('product_status')"
                                  :class="
                                    (this.$data.sortType == 'asc' ||
                                      this.$data.sortType == 'ASC') &&
                                    this.$data.sortBy == 'product_status'
                                      ? 'sorting_asc'
                                      : (this.$data.sortType == 'desc' ||
                                          this.$data.sortType == 'DESC') &&
                                        this.$data.sortBy == 'product_status'
                                      ? 'sorting_desc'
                                      : 'sorting'
                                  ">
                                  Статус
                                </th>
                                <th v-if="$parent.permissions.includes('product-manage')" class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 20px">
                                </th>
                              </tr>
                            </thead>
                            <tbody class="kt-table-tbody text-dark">
                              <template v-for="product in products">
                                <tr class="kt-table-row kt-table-row-level-0 odd" product="row" v-bind:key="product.id">
                                  <td class="sorting_1" style="text-align: center;font-weight: bold">{{ product.product_id }}</td>
                                  <td><img alt="" style="width: 50px;border-radius: 5px;" :src="typeof(product.image) !== null ? product.image : '' "/></td>
                                  <td>
                                    {{
                                      product.product_title == null
                                        ? ""
                                        : product.product_title
                                    }}
                                  </td>

  <!--                                <td>{{ // getCategoryText(product.category) }}</td>-->
                                  <td class="d-none">{{ product.product_type }}</td>
                                  <td v-if="product.product_discount_price_symbol > 0">
                                    <div class="d-flex align-items-center" v-if="product.isEditing">
                                      <input
                                        v-model.number="product.product_price"
                                        type="number"
                                        step="0.01"
                                        class="form-control"
                                        style="width: 85px;"
                                        @keyup.enter="savePrice(product)"
                                      />
                                      <i class="fas fa-save text-success fa-lg mx-1" style="cursor: pointer;" @click="savePrice(product)" title="Save"></i>
                                      <i class="fas fa-times text-secondary fa-lg mx-1" style="cursor: pointer;" @click="cancelEdit(product)" title="Cancel"></i>
                                    </div>
                                    <div v-else>
                                      {{ (product.product_discount_price_symbol).toFixed(2) }} {{ currencySymbol }} <br>
                                      <span style="text-decoration:line-through; color: #aaa;">
                                        {{ (product.product_price).toFixed(2) }} {{ currencySymbol }}
                                      </span>
                                      <i class="fas fa-edit text-primary fa-lg mx-1" style="cursor: pointer;" @click="enableEdit(product)" title="Edit"></i>
                                    </div>
                                  </td>
                                  <td v-else>
                                    <div class="d-flex align-items-center" v-if="product.isEditing">
                                      <input
                                        v-model.number="product.product_price"
                                        type="number"
                                        step="0.01"
                                        class="form-control"
                                        style="width: 85px;"
                                        @keyup.enter="savePrice(product)"
                                      />
                                      <i class="fas fa-save text-success fa-lg mx-1" style="cursor: pointer;" @click="savePrice(product)" title="Save"></i>
                                      <i class="fas fa-times text-secondary fa-lg mx-1" style="cursor: pointer;" @click="cancelEdit(product)" title="Cancel"></i>
                                    </div>
                                    <div v-else>
                                      {{ (product.product_price).toFixed(2) }} {{ currencySymbol }}
                                      <i class="fas fa-edit text-primary fa-lg mx-1" style="cursor: pointer;" @click="enableEdit(product)" title="Edit"></i>
                                    </div>
                                  </td>
                                  <td>
                                    <div v-if="product.b2b_price">
                                      {{ Number(product.b2b_price).toFixed(2) }} ₽
                                      <span
                                        v-if="product.price_is_manual"
                                        title="Цена задана вручную, пересчёт её не трогает"
                                        style="color: #b8860b;"
                                      >&#128274;</span>
                                      <br>
                                      <span style="color: #888;" title="Специальная цена, применяется для способов оплаты со скидкой">
                                        спец. {{ Number(product.b2b_special_price).toFixed(2) }} ₽
                                      </span>
                                    </div>
                                    <div v-else style="color: #aaa;">&mdash;</div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center" v-if="product.isEditingPurchasePrice">
                                      <input
                                        v-model.number="product.purchase_price_usd"
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        class="form-control"
                                        style="width: 85px;"
                                        @keyup.enter="savePurchasePrice(product)"
                                      />
                                      <span class="mx-1">$</span>
                                      <i class="fas fa-save text-success fa-lg mx-1" style="cursor: pointer;" @click="savePurchasePrice(product)" title="Save"></i>
                                      <i class="fas fa-times text-secondary fa-lg mx-1" style="cursor: pointer;" @click="cancelEditPurchasePrice(product)" title="Cancel"></i>
                                    </div>
                                    <div v-else>
                                      <div v-if="product.purchase_price_usd">
                                        {{ (product.purchase_price_usd).toFixed(2) }} $
                                        <i class="fas fa-edit text-primary fa-lg mx-1" style="cursor: pointer;" @click="enableEditPurchasePrice(product)" title="Edit"></i>
                                        <br>
                                        <span style="color: #888;">
                                          {{ (product.purchase_price_rub).toFixed(2) }} ₽
                                        </span>
                                      </div>
                                      <div v-else style="color: #aaa;">
                                        <i class="fas fa-edit text-primary fa-lg mx-1" style="cursor: pointer;" @click="enableEditPurchasePrice(product)" title="Edit"></i>
                                      </div>
                                    </div>
                                  </td>
  <!--                                <td>SKU: {{ product.product_sku }}<br>EAN: {{ product.product_ean }}<br>Barcode: {{ product.product_barcode }}</td>-->
                                  <td>{{ product.product_sku }}</td>
                                  <td class="text-right">
                                    <!-- Show expand icon if product has combinations -->
                                    <div v-if="product.product_type === 'variable' && product.combinations && product.combinations.length > 0">
                                      <div style="display: flex; align-items: center; justify-content: flex-end;">
                                        <span>{{ (product.available_qty) }}</span>
                                        <i
                                          :class="product.showCombinations ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
                                          class="text-info fa-lg mx-1"
                                          style="cursor: pointer;"
                                          @click="toggleCombinations(product)"
                                          title="Показать вариации"
                                        ></i>
                                      </div>

                                      <!-- Show combinations list when expanded -->
                                      <div v-if="product.showCombinations" style="text-align: left; margin-top: 10px; padding-top: 10px; border-top: 1px solid #ddd;">
                                        <div v-for="(combination, index) in product.combinations" :key="combination.id" style="margin-bottom: 8px; padding: 4px 0; border-bottom: 1px solid #eee;">
                                          <div style="display: flex; justify-content: space-between; align-items: center;">
                                            <div style="flex: 1; min-width: 0; font-size: 11px; color: #666;">
                                              <div style="font-weight: 500; color: #333; margin-bottom: 2px;">{{ combination.combination_string || '—' }}</div>
                                              <div style="color: #888;">{{ combination.sku || '—' }}</div>
                                            </div>
                                            <div style="display: flex; align-items: center; margin-left: 10px;">
                                              <div v-if="combination.isEditingQty" style="display: flex; align-items: center;">
                                                <input
                                                  v-model.number="combination.available_qty"
                                                  type="number"
                                                  step="1"
                                                  min="0"
                                                  class="form-control form-control-sm"
                                                  style="width: 60px; height: 28px; font-size: 12px;"
                                                  @keyup.enter="saveCombinationQuantity(product, combination)"
                                                />
                                                <i class="fas fa-save text-success mx-1" style="cursor: pointer; font-size: 14px;" @click="saveCombinationQuantity(product, combination)" title="Save"></i>
                                                <i class="fas fa-times text-secondary mx-1" style="cursor: pointer; font-size: 14px;" @click="cancelEditCombinationQty(combination)" title="Cancel"></i>
                                              </div>
                                              <div v-else style="display: flex; align-items: center;">
                                                <span style="font-weight: 600; min-width: 30px; text-align: right;">{{ combination.available_qty || 0 }}</span>
                                                <i class="fas fa-edit text-primary mx-1" style="cursor: pointer; font-size: 14px;" @click="enableEditCombinationQty(combination)" title="Edit"></i>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- Show editable field for simple products -->
                                    <div v-else>
                                      <div class="d-flex align-items-center justify-content-end" v-if="product.isEditingQty">
                                        <input
                                          v-model.number="product.available_qty"
                                          type="number"
                                          step="1"
                                          min="0"
                                          class="form-control"
                                          style="width: 85px;"
                                          @keyup.enter="saveQuantity(product)"
                                        />
                                        <i class="fas fa-save text-success fa-lg mx-1" style="cursor: pointer;" @click="saveQuantity(product)" title="Save"></i>
                                        <i class="fas fa-times text-secondary fa-lg mx-1" style="cursor: pointer;" @click="cancelEditQty(product)" title="Cancel"></i>
                                      </div>
                                      <div v-else>
                                        {{ (product.available_qty) }}
                                        <i class="fas fa-edit text-primary fa-lg mx-1" style="cursor: pointer;" @click="enableEditQty(product)" title="Edit"></i>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="text-center">
                                      <div class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                          <input
                                              type="checkbox"
                                              class="custom-control-input"
                                              :id="`customSwitchStatus${product.product_id}`"
                                              :checked="product.product_status === 'active'"
                                              v-on:input="(event) => { setProductStatus(event.target.checked, product) }"
                                          />
                                          <label class="custom-control-label mr-1" :for="`customSwitchStatus${product.product_id}`"></label>
                                      </div>
                                  </td>

                                  <td v-if="$parent.permissions.includes('product-manage')">
                                      <router-link
                                          :to="{path:'/admin/add-product/' + product.product_id,}"
                                          class="btn ml-2 p-0 kt_notes_panel_toggle"
                                          data-toggle="tooltip"
                                          title=""
                                          data-placement="right"
                                          data-original-title="Copy"
                                          v-if="$parent.permissions.includes('product-manage')"
                                      ><i class="fa fa-copy"></i>
                                      </router-link>
                                      <router-link
                                      :to="{path:'/admin/product/' + product.product_id,}"
                                      class="click-edit"
                                      id="click-edit1"
                                      data-toggle="tooltip"
                                      title=""
                                      data-placement="right"
                                      data-original-title="Edit"
                                      @click="editproduct(product)"
                                      ><i class="fa fa-edit"></i>
                                    </router-link>
                                    <a class="" href="#" @click="deleteproduct(product.product_id)"><i class="fa fa-trash"></i></a>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                          <Pagination :currentPage="pagination.current_page" :totalPage="pagination.last_page" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel"
      v-if="display_form"
      :class="display_form ? 'offcanvas-on' : ''"
    >
      <div
        class="
          offcanvas-header
          d-flex
          align-items-center
          justify-content-between
          pb-3
        "
      >
        <h4 class="font-size-h4 font-weight-bold m-0">Добавить товар</h4>
        <a
          href="#"
          class="
            btn btn-sm btn-icon btn-light btn-hover-primary
            kt_notes_panel_close
          "
          v-on:click="display_form = 0"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 16 16"
            class="bi bi-x"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            ></path>
          </svg>
        </a>
      </div>
      <form id="myform">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="text-dark">Name </label>
              <input
                type="text"
                name="text"
                v-model="product.name"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('name')"
                v-text="errors.get('name')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Direction </label>
              <select v-model="product.direction">
                <option value="ltr">LTR</option>
                <option value="rtl">RTL</option>
              </select>
              <small
                class="form-text text-danger"
                v-if="errors.has('direction')"
                v-text="errors.get('direction')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Code </label>
              <input
                type="text"
                name="text"
                v-model="product.code"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('code')"
                v-text="errors.get('code')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Directory </label>
              <input
                type="text"
                name="text"
                v-model="product.directory"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('directory')"
                v-text="errors.get('directory')"
              ></small>
            </div>
            <div class="form-group">
              <input
                type="checkbox"
                name="text"
                v-model="product.is_default"
                id="is_default"
                class="form-check-input"
              />
              <label class="text-dark" for="is_default">Set as default </label>
              <small
                class="form-text text-danger"
                v-if="errors.has('is_default')"
                v-text="errors.get('is_default')"
              ></small>
            </div>
          </div>
        </div>
        <button
          type="button"
          @click="addUpdateproduct()"
          class="btn btn-primary"
        >
          Submit
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import ErrorHandling from "./../../ErrorHandling";
import Pagination from './Pagination';
import Multiselect from 'vue-multiselect';
export default {
  data() {
    return {
      timer: null,
      display_form: 0,
      products: [],
      searchParameter: this.$route.query.searchParameter || null,
      filterCategory: this.$route.query.productCategories || '',
      selectedCategory: null,
      filterCollection: this.$route.query.productCollections || '',
      filterStatus: this.$route.query.productStatus || '',
      filterStock: this.$route.query.stockStatus || '',
      categories: [],
      collections: [],
      sortBy: "id",
      sortType: "DESC",
      limit: this.$route.query.limit || 10,
      error_message: "",
      edit: false,
      actions: false,
      pagination: {
        current_page: 1,
        last_page: 1
      },
      request_method: "",
      is_default: "0",
      token: [],
      currency: [],
      errors: new ErrorHandling(),
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      statusText: {
          in_storage: 'на складе',
          in_stock: 'в наличии',
          preorder: 'предзаказ'
      },
    };
  },
  components:{
    Pagination,
    Multiselect
  },

  computed: {
    currencySymbol() {
      return window.appConfig?.currencySymbol || '€';
    }
  },

  methods: {
      toggleCombinations(product) {
        this.$set(product, 'showCombinations', !product.showCombinations);
      },

      enableEditCombinationQty(combination) {
        combination.original_qty = combination.available_qty;
        this.$set(combination, 'isEditingQty', true);
      },

      cancelEditCombinationQty(combination) {
        combination.available_qty = combination.original_qty;
        this.$set(combination, 'isEditingQty', false);
      },

      saveCombinationQuantity(product, combination) {
        this.$parent.loading = true;
        const data = {
          quantity: combination.available_qty,
          product_combination_id: combination.id,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/quantity`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(combination, 'isEditingQty', false);

              // Refresh products to get updated quantities
              this.fetchproducts();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update combination quantity");
            } else {
              this.$toaster.error("An error occurred while updating the combination quantity");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      enableEdit(product) {
        product.original_price = product.product_price;
        this.$set(product, 'isEditing', true);
      },

      cancelEdit(product) {
        product.product_price = product.original_price;
        this.$set(product, 'isEditing', false);
      },

      enableEditQty(product) {
        product.original_qty = product.available_qty;
        this.$set(product, 'isEditingQty', true);
      },

      cancelEditQty(product) {
        product.available_qty = product.original_qty;
        this.$set(product, 'isEditingQty', false);
      },

      saveQuantity(product) {
        this.$parent.loading = true;
        const data = {
          quantity: product.available_qty,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/quantity`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(product, 'isEditingQty', false);

              this.fetchproducts();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update quantity");
            } else {
              this.$toaster.error("An error occurred while updating the quantity");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      savePrice(product) {
        this.$parent.loading = true;
        const data = {
          product_price: product.product_price,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/price`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(product, 'isEditing', false);

              this.fetchproducts();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update price");
            } else {
              this.$toaster.error("An error occurred while updating the price");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      enableEditPurchasePrice(product) {
        // Initialize purchase_price_usd to 0 if it's null or undefined
        if (!product.purchase_price_usd) {
          product.purchase_price_usd = 0;
        }
        product.original_purchase_price = product.purchase_price_usd;
        this.$set(product, 'isEditingPurchasePrice', true);
      },

      cancelEditPurchasePrice(product) {
        product.purchase_price_usd = product.original_purchase_price;
        this.$set(product, 'isEditingPurchasePrice', false);
      },

      savePurchasePrice(product) {
        this.$parent.loading = true;
        const data = {
          purchase_price: product.purchase_price_usd,
        };

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        axios
          .put(`/api/admin/product/${product.product_id}/purchase-price`, data, config)
          .then((res) => {
            if (res.data.status === "Success") {
              this.$toaster.success(res.data.message);
              this.$set(product, 'isEditingPurchasePrice', false);

              this.fetchproducts();
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.$toaster.error(error.response.data.message || "Failed to update purchase price");
            } else {
              this.$toaster.error("An error occurred while updating the purchase price");
            }
          })
          .finally(() => {
            this.$parent.loading = false;
          });
      },

      getCategoryText(category){
          try {
              let text = '';
              return category.map((item) => {
                  return `${this.getParentCategoryText(item.category_detail)}`
              }).join(', ')
          } catch (e){
              console.log(e)
              return '';
          }

          console.log(category)

          return '';
      },
      getParentCategoryText(category){
          let text = '';
        if(category.parent_category) {
            text += this.getParentCategoryText(category.parent_category) + ' → ';
        }
        text += category.detail[0].name;
        return text;
      },
      setProductStatus(value, product){
          axios.put(`/api/admin/product/${product.product_id}/product-status`, {product_status: value}, this.token);
      },
      setProductStatusEE(value, product){
          axios.put(`/api/admin/product/${product.product_id}/product-status`, {product_status_ee: value}, this.token);
      },
    fetchCurrency() {
      this.$parent.loading = true;
      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var responseData = {};

      axios
        .get("/api/admin/currency?is_default=1", config)
        .then((res) => {
          if (res.data.status == "Success") {
            this.currency = res.data.data;
          }
        })
        .finally(() => (this.$parent.loading = false));
    },
    searchProducts(){
        if(this.timer){
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.fetchproducts(1);
        }, 1000)
    },

    fetchproducts(page = null, limit = null, searchParameter = null) {
      this.pagination.current_page = page = page === null ? (this.$route.query.page || this.pagination.current_page) : page;
      this.limit = limit = limit || this.limit;
      this.searchParameter = searchParameter = searchParameter || this.searchParameter;

      const routeQuery = { page, limit, searchParameter };
      if (this.filterCategory) routeQuery.productCategories = this.filterCategory;
      if (this.filterCollection) routeQuery.productCollections = this.filterCollection;
      if (this.filterStatus) routeQuery.productStatus = this.filterStatus;
      if (this.filterStock) routeQuery.stockStatus = this.filterStock;
      this.$router.push({ name: 'product-list', query: routeQuery }).catch(() => {});

      this.$parent.loading = true;
      let page_url = `/api/admin/product/product-list?page=${page}&limit=${limit}`;

      if (searchParameter) {
        page_url += `&searchParameter=${searchParameter}`;
      }
      if (this.filterCategory) {
        page_url += `&productCategories=${this.filterCategory}`;
      }
      if (this.filterCollection) {
        page_url += `&productCollections=${this.filterCollection}`;
      }
      if (this.filterStatus) {
        page_url += `&productStatus=${this.filterStatus}`;
      }
      if (this.filterStock) {
        page_url += `&stockStatus=${this.filterStock}`;
      }

      page_url += `&sortBy=${this.sortBy}&sortType=${this.sortType}&getDetail=1&getCategory=1`;

      axios
        .get(page_url, this.token)
        .then((res) => {
          this.products = res.data.data.map((product) => {
            // Initialize each product
            const initializedProduct = {
              ...product,
              isEditing: false,
              isEditingQty: false,
              isEditingPurchasePrice: false,
              showCombinations: false,
            };

            // Initialize combinations if they exist
            if (initializedProduct.combinations && Array.isArray(initializedProduct.combinations)) {
              initializedProduct.combinations = initializedProduct.combinations.map(combination => ({
                ...combination,
                isEditingQty: false,
              }));
            }

            return initializedProduct;
          });
          this.makePagination(res.data.meta, res.data.links);
        })
        .finally(() => (this.$parent.loading = false));
    },

    makePagination(meta) {
      this.pagination.current_page = meta.current_page;
      this.pagination.last_page = meta.last_page;
    },

    sorting(sortBy) {
      this.sortBy = sortBy;
      this.sortType =
        this.sortType == "asc" || this.sortType == "ASC"
          ? (this.sortType = "desc")
          : (this.sortType = "asc");
      this.fetchproducts();
    },
    getCurrencyTitle() {
      return this.currency == null ? "" : "(" + this.currency.title + ")";
    },
    deleteproduct(id) {
      if (confirm("Are You Sure?")) {
        this.$parent.loading = true;
        axios
          .delete(`/api/admin/product/${id}`, this.token)
          .then((res) => {
            if (res.data.status == "Success") {
              this.$toaster.success(res.data.message);
              this.fetchproducts();
            }
          })
          .catch((error) => {
            if (error.response.status == 422) {
						if(error.response.data.status == 'Error'){
                             this.$toaster.error(error.response.data.message)
						} }
          })
          .finally(() => (this.$parent.loading = false));
      }
    },
    clearSearch(){
      this.searchParameter = "",
      this.fetchproducts();
    },
    applyFilters() {
      this.fetchproducts(1);
    },
    clearFilters() {
      this.filterCategory = '';
      this.selectedCategory = null;
      this.filterCollection = '';
      this.filterStatus = '';
      this.filterStock = '';
      this.searchParameter = '';
      this.fetchproducts(1);
    },
    categoryLabel(cat) {
      if (!cat) return '';
      return cat.detail && cat.detail[0] ? cat.detail[0].name : ('#' + cat.id);
    },
    onCategorySelect(val) {
      this.filterCategory = val ? val.id : '';
      this.fetchproducts(1);
    },
    fetchFilterOptions() {
      const token = localStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      axios
        .get("/api/admin/category?getAllData=1&getDetail=1", config)
        .then((res) => {
          if (res.data.status === "Success") {
            this.categories = res.data.data;
            // Restore selected category from URL param after options load
            if (this.filterCategory) {
              this.selectedCategory = this.categories.find(
                (c) => String(c.id) === String(this.filterCategory)
              ) || null;
            }
          }
        })
        .catch(() => {});
      axios
        .get("/api/admin/collection?getAllData=1&getDetail=1", config)
        .then((res) => {
          if (res.data.status === "Success") {
            this.collections = res.data.data;
          }
        })
        .catch(() => {});
    },
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchCurrency();
    this.fetchFilterOptions();
    this.fetchproducts();

    this.$on('page-changed', page => {
      this.fetchproducts(page);
    });
  },
  props: ["loading"],
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.product_toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 8px;
}
.product_toolbar .ptf-item {
  display: flex;
  flex-direction: column;
}
.product_toolbar .ptf-item > label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;
}
.product_toolbar select,
.product_toolbar input[type="text"] {
  height: 38px;
  border: 1px solid #d1d5db !important;
  border-radius: 6px !important;
  padding: 0 10px;
  font-size: 14px;
  color: #111827;
  background-color: #fff;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;
}
.product_toolbar select:focus,
.product_toolbar input[type="text"]:focus,
.product_toolbar .ptf-multiselect.multiselect--active .multiselect__tags {
  border-color: #7c6df2 !important;
  box-shadow: 0 0 0 2px rgba(124, 109, 242, 0.15) !important;
}
.product_toolbar .ptf-count select { width: 84px; min-width: 84px; }
.product_toolbar .ptf-search input[type="text"] { width: 230px; }
.product_toolbar select { min-width: 170px; }
.product_toolbar .ptf-search-wrap { display: flex; align-items: center; gap: 6px; }
.product_toolbar .ptf-search-wrap button {
  height: 38px; width: 34px; flex: 0 0 34px;
  border: 1px solid #d1d5db; border-radius: 6px;
  background: #f9fafb; color: #6b7280; cursor: pointer;
  font-size: 18px; line-height: 1;
}
.product_toolbar .ptf-search-wrap button:hover { background: #f3f4f6; }
.product_toolbar .ptf-reset button {
  height: 38px; padding: 0 16px;
  border: 1px solid #d1d5db; border-radius: 6px;
  background: #f9fafb; color: #374151; cursor: pointer;
  font-size: 13px; white-space: nowrap;
}
.product_toolbar .ptf-reset button:hover { background: #f3f4f6; }

/* vue-multiselect aligned to 38px controls */
.product_toolbar .ptf-multiselect {
  min-width: 240px;
  min-height: 38px;
}
.product_toolbar .ptf-multiselect .multiselect__tags {
  min-height: 38px;
  height: 38px;
  box-sizing: border-box;
  padding: 7px 40px 0 10px;
  border: 1px solid #d1d5db !important;
  border-radius: 6px !important;
  font-size: 14px;
  box-shadow: none !important;
}
.product_toolbar .ptf-multiselect .multiselect__select { height: 36px; }
.product_toolbar .ptf-multiselect .multiselect__single,
.product_toolbar .ptf-multiselect .multiselect__placeholder,
.product_toolbar .ptf-multiselect .multiselect__input {
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  padding-top: 0;
  min-height: 22px;
}
.product_toolbar .ptf-multiselect .multiselect__placeholder { color: #9ca3af; padding-top: 0; }
.product_toolbar .ptf-multiselect .multiselect__input {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  caret-color: transparent !important;
}
</style>
